import React, { useEffect, useRef, useState } from "react";
import leftArrow from "../../Assets/Images/Revenue-management/leftArrow.svg";
import rightArrow from "../../Assets/Images/Revenue-management/rightArrow.svg";
import soldOutIcon from "../../Assets/Images/Revenue-management/soldout.svg";


import {
    Badge,
    Button,
    Col,
    FloatingLabel,
    Form,
    Modal,
    Row,
    Tab,
    Table,
    Tabs,
} from "react-bootstrap";
import moment from "moment";
import { commonService } from "../../utils/commonService";
import { apiResponse } from "../../utils/apiResponse";
import { apiCall } from "../../utils/axiosService";
import { API_URL } from "../../utils/apiRoutes";
import {
    Chart,
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend,
    PointElement,
    LineElement,
    Filler,
} from "chart.js";
import { Line } from "react-chartjs-2";
import RateShopHistoryChartModal from "./ListingComponent/RateShop/RateShopHistoryChartModal";
import Loader from "../Loader/Loader";
import { useSelector } from "react-redux";
import downArrow from "../../Assets/Images/Header/downArrow.svg";

function CompSetVarianceChart({
    showToolsSummaryModal,
    closeToolsSummaryModal,
    selectedDate,
    propertyDetail,
    CompetitorProperty
}) {

    const [date, setDate] = useState(
        moment(new Date(selectedDate)).format("MMMM DD YYYY")
    );

    const [loading, setLoading] = useState(false);


    const allLastDates = useSelector((store) => store.headerProperty.allDates);

    const [dtCollected, setDTcollected] = useState(null);
    const [chartData, setChartData] = useState(null);
    const datesArrRef = useRef();
    const isSelfRef = useRef();

    const getChartDetail = async () => {
        setLoading(true)
        setChartData(null);
        let asOfDateResponse = await apiCall(
            {
                method: "POST",
                url: API_URL.BASE_API_URL.SnapShot + API_URL.AS_OF_DATE.AS_OF_DATE,
                body: { propertyCode: propertyDetail?.propertycode },
            },
            false
        );

        if (asOfDateResponse?.status_code === 1) {
            let chartDetailResponse = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASE_API_URL.SnapShot + API_URL.RATEIQ.GET_CHART,
                    body: {
                        AsOfDate: asOfDateResponse?.data?.[0]?.last_data_refresh
                            ? asOfDateResponse?.data?.[0]?.last_data_refresh
                            : `${commonService.getDateForNode(new Date())} 00:00:00`,
                        CheckInDate: moment(date).format("YYYY-MM-DD"),
                        propertyCode: propertyDetail?.propertycode,
                        propertyid: propertyDetail?.propertyid,
                        Channel: propertyDetail?.chain_term,
                    },
                },
                false
            );

            let response = apiResponse(false, chartDetailResponse);
            setLoading(false)
            if (response?.isValidate) {
                let startDate = commonService.convertDateInTimezone(
                    asOfDateResponse?.data?.[0]?.last_data_refresh
                        ? asOfDateResponse?.data?.[0]?.last_data_refresh
                        : new Date()
                );
                let ed = moment(startDate).toDate();
                ed.setDate(ed.getDate() - 32);
                let endDate = commonService.convertDateInTimezone(ed);

                let datesArr = commonService.getDateBetweenTwoDates(
                    commonService.convertDateInTimezone(endDate),
                    commonService.convertDateInTimezone(startDate)
                );
                datesArrRef.current = datesArr;

                let dataFromApi = response?.data?.data?.rateiqchart;

                let groupingJson = {};
                let tmpDT_Date = null;

                datesArr?.map((item) => {
                    let findDataFromApi = dataFromApi?.filter(
                        (x) =>
                            moment(x?.AsOfDate).format("YYYY-MM-DD") ===
                            moment(item).format("YYYY-MM-DD")
                    );

                    const currentDate = findDataFromApi?.[0]?.dtcollected;
                    if (
                        currentDate &&
                        (!tmpDT_Date || moment(currentDate).isAfter(tmpDT_Date))
                    ) {
                        tmpDT_Date = currentDate;
                    }

                    Object?.entries(findDataFromApi?.[0])?.map(([key, value]) => {
                        if (key !== "CheckInDate" && key !== "AsOfDate") {
                            if (key === CompetitorProperty || key === "self") {
                                if (groupingJson[key]) {
                                    groupingJson[key] = [...groupingJson[key], value ? value : 0];
                                } else {
                                    groupingJson[key] = [value ? value : 0];
                                }
                            }
                        }
                    });                    
                });

                //let dataForMl = response?.data?.data?.ml_rate;
                //groupingJson = { ...groupingJson, "ML Rate": [] };

                //datesArr?.map((item) => {
                //    let findDataFromApi = dataForMl?.filter(
                //        (x) =>
                //            moment(x?.AsOfDate).format("YYYY-MM-DD") ===
                //            moment(item).format("YYYY-MM-DD")
                //    );

                //    groupingJson["ML Rate"]?.push(
                //        findDataFromApi?.[0]?.ml_rate ? findDataFromApi?.[0]?.ml_rate : 0
                //    );
                //});
                const formattedDate = moment.utc(tmpDT_Date).local().format("MM/DD/YYYY hh:mm A");

                setChartData(groupingJson);
                setDTcollected(formattedDate);
            }

            if (!response?.isValidate) {
                setChartData(null);
            }
        }
    };

    useEffect(() => {
        getChartDetail();
    }, [date]);


    let mergedData = {},
        options = {};

    if (chartData) {
        options = {
            elements: {
                point: {
                    radius: 0,
                },
            },
            scales: {
                x: {
                    title: {
                        display: true,
                        text: "LeadTime",
                    },
                    grid: {
                        display: false,
                    },
                },
                y: {
                    stacked: false,
                    beginAtZero: true,
                    type: "linear",
                    position: "left",
                    ticks: {
                        stepSize: 10,
                        callback: function (value, index, values) {
                            return `$ ${value}`;
                        },
                    },
                },
            },
            plugins: {
                legend: {
                    display: true,
                    align: "center",
                    position: "bottom",
                    paddingTop: 10,
                    maxWidth: 20,
                    maxHeight: 100,
                    labels: {
                        boxWidth: 10,
                        boxHeight: 10,
                    },
                },
                tooltip: {
                    enabled: true,
                    mode: "index",
                    callbacks: {
                        title: function (context) {
                            let labelText = context[0].label || "";
                            let index = context[0].dataIndex;
                            let date = datesArrRef.current[index];
                            let formatedDate = moment(date).format("dddd MMMM D YYYY");
                            return `Leadtime ${labelText} ${formatedDate}`;
                        },
                        label: function (context) {
                            let label = context.dataset.label || "";
                            return `${label}: $${context.raw}`;
                        },
                    },
                },
            },
            responsive: true,
            maintainAspectRatio: true,
            aspectRatio: 4 / 1,
        };
        let dataSetDetail = Object?.entries(chartData)?.map(([key, value]) => {
            let color = commonService.CreateColor(`${key}`).BGColor;
            return {
                type: "line",
                label: key,
                data: value,
                fill: false,
                backgroundColor: isSelfRef.current === key ? "#134AFF" : `${color}`,
                borderColor: isSelfRef.current === key ? "#134AFF" : `${color}`,
                borderWidth: isSelfRef.current === key ? 5 : 2,
                order: 0,
                pointRadius: 5,
                pointBorderWidth: 4,
                pointBorderColor: "#ffffff",
                pointBorderRadius: 10,
            };
        });

        mergedData = {
            labels: [
                32, 31, 30, 29, 28, 27, 26, 25, 24, 23, 22, 21, 20, 19, 18, 17, 16, 15,
                14, 13, 12, 11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1, 0,
            ],
            datasets: dataSetDetail,
        };
    }

    Chart.register(
        CategoryScale,
        LinearScale,
        BarElement,
        Tooltip,
        Legend,
        PointElement,
        LineElement,
        Filler
    );

    return (
        <>
            <Modal
                className="ToolsSummaryModalMain"
                size="xl"
                centered
                show={showToolsSummaryModal}
                onHide={closeToolsSummaryModal}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        
                        <div className="toolSummaryModalHeader">
                            <div className="dateWithArrow m-0">
                                <img id={commonService.generateGlobalClickTrackerID("CompSetVarianceChart", "leftarrow", "")}
                                    src={leftArrow}
                                    alt="leftArrow"
                                    onClick={() => {
                                        let d = new Date(commonService.getDateInFormat(date));
                                        d.setDate(d.getDate() - 1);
                                        setDate(moment(d).format("MMMM DD YYYY"));
                                    }}
                                />
                                <p>{date}</p>
                                <img id={commonService.generateGlobalClickTrackerID("CompSetVarianceChart", "rightarrow", "")}
                                    src={rightArrow}
                                    alt="rightArrow"
                                    onClick={() => {
                                        let d = new Date(commonService.getDateInFormat(date));
                                        d.setDate(d.getDate() + 1);
                                        setDate(moment(d).format("MMMM DD YYYY"));
                                    }}
                                />
                            </div>
                            <div>
                                {/* {allLastDates?.rateshopDate && (
                                    <p>{allLastDates?.rateshopDate}</p>
                                )} */}
                                {dtCollected && (
                                    <p>{dtCollected}</p>
                                )}
                            </div>
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loading ? (
                        <Loader />
                    ) : chartData ? (
                        <div className="GroupNameModalBody">
                            <Line data={mergedData} options={options} />
                        </div>
                    ) : (
                        <>
                            <p>No Data Found</p>
                        </>
                    )}
                </Modal.Body>
            </Modal>
        </>
    );
}

export default CompSetVarianceChart;
